export function getTextVariantProps(props) {
    if (props.span)
        props.variant = 'span';
    if (props.p)
        props.variant = 'p';
    if (props.code)
        props.variant = 'code';
    var classes = {
        '__label': true,
    };
    return {
        classes: classes,
        props: {},
        styles: {},
        variables: {
            variant: props.variant || 'span'
        }
    };
}
